import axios from './axios';
import { DashboardUser } from '../shared';

export default async function getCurrentUser(): Promise<DashboardUser> {
  const response = await axios.get('/user');
  return response.data.user;
}
